module.exports = __webpack_public_path__ + "static/media/unico-erp.1ec37705.png";